import { useOutletContext } from 'react-router-dom';

import { PlateformeDto } from 'api/plateforme';
import { PlateformeBrokers } from '../PlateformeBrokers';
import { HabilitationsTunnelsManager } from '../habilitations-tunnels/components/HabilitationsTunnelsManager';
import { PlateformeGovernanceTab } from './PlateformeGovernanceTab';
import { PlateformeDroitsTab } from './PlateformeDroitsTab';
import { PlateformeCatalogueTab } from './PlateformeCatalogueTab';

/** Contexte fourni par PlateformeDetails à ses routes d'onglet (Outlet). */
export interface PlateformeOutletContext {
  plateformeId: string;
  plateforme: PlateformeDto;
  /** Rafraîchit la fiche (le header affiche le nom de la PM gérante). */
  refreshPlateforme: () => void;
  /** Ouvre le panneau d'ajout d'un courtier dans la plateforme. */
  openAddBrokerForm: () => void;
}

/**
 * Routes d'onglet de la fiche plateforme : l'URL est la source de vérité
 * (/plateformes/{id}/gouvernance, /catalogue…) — chaque wrapper lit le
 * contexte de l'Outlet et rend l'onglet correspondant.
 */
export const PlateformeGouvernanceRoute: React.FC = () => {
  const ctx = useOutletContext<PlateformeOutletContext>();
  return (
    <PlateformeGovernanceTab
      plateformeId={ctx.plateformeId}
      onPlateformeUpdated={ctx.refreshPlateforme}
      modeGestion={ctx.plateforme.modeGestion}
    />
  );
};

export const PlateformeIntermediairesRoute: React.FC = () => {
  const ctx = useOutletContext<PlateformeOutletContext>();
  return (
    <PlateformeBrokers
      plateformeId={ctx.plateformeId}
      modeGestion={ctx.plateforme.modeGestion}
      onCreateConfig={{
        label: 'Ajouter un courtier dans la plateforme',
        onClick: ctx.openAddBrokerForm
      }}
    />
  );
};

export const PlateformeCatalogueRoute: React.FC = () => {
  const ctx = useOutletContext<PlateformeOutletContext>();
  return (
    <PlateformeCatalogueTab plateformeId={ctx.plateformeId} />
  );
};

export const PlateformeRolesRoute: React.FC = () => {
  const ctx = useOutletContext<PlateformeOutletContext>();
  return <PlateformeDroitsTab plateformeId={ctx.plateformeId} />;
};

export const PlateformeHabilitationsRoute: React.FC = () => {
  const ctx = useOutletContext<PlateformeOutletContext>();
  return <HabilitationsTunnelsManager plateformeId={ctx.plateformeId} />;
};
